import { API_URL } from "@/config/constants";
import axios, { AxiosProgressEvent } from "axios";
import { IFileUpload, IPresignedUrl } from "./media.types";

const storageAxios = axios.create({
    headers: {},
});
delete storageAxios.defaults.headers.common["Authorization"];

const API = `${API_URL}/media`;

export const getPresignedUrl = async (fileInfo: IFileUpload) => {
    const result = await axios.post<IPresignedUrl>(`${API}/presign`, fileInfo);
    return result.data;
};

export const getPublicPresignedUrl = async (fileInfo: IFileUpload) => {
    const result = await axios.post<IPresignedUrl>(
        `${API}/presign-public`,
        fileInfo
    );
    return result.data;
};

export const uploadToStorage = async (
    file: File,
    presignedUrl: IPresignedUrl,
    onUploadProgress?: (progressEvent: AxiosProgressEvent) => void
) => {
    await storageAxios.put(presignedUrl.url, file, {
        headers: {
            "Content-Type": file.type,
        },
        onUploadProgress,
    });

    return presignedUrl.object_name;
};
